(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-libs/trajectory/assets/javascripts/webcomponent.js') >= 0) return;  svs.modules.push('/components/lb-libs/trajectory/assets/javascripts/webcomponent.js');
class EventComponent extends HTMLElement {
  data;
  intervalId;
  openStates = new Map();

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  static get observedAttributes() {
    return ['eventid'];
  }

  get eventId() {
    return this.getAttribute('eventid');
  }

  set eventId(value) {
    this.setAttribute('eventid', value);
  }

  connectedCallback() {
    if (this.eventId) {
      this.loadData(this.eventId);
      this.startAutoRefresh(this.eventId);
    }
  }

  disconnectedCallback() {
    clearInterval(this.intervalId);
  }

  attributeChangedCallback(attrName, oldVal, newVal) {
    if (attrName.toLowerCase() === 'eventid' && newVal !== oldVal) {
      this.loadData(newVal);
      this.startAutoRefresh(newVal);
    }
  }

  async loadData(eventid) {
    try {
      const response = await fetch(`https://api.travappar.se/v0/racedata/${eventid}`);
      this.data = await response.json();
      this.renderHtml();
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  startAutoRefresh(eventid) {
    clearInterval(this.intervalId);
    this.intervalId = setInterval(async () => {
      try {
        const response = await fetch(`https://api.travappar.se/v0/racedata/${eventid}`);
        this.data = await response.json();
        this.renderHtml();
      } catch (error) {
        console.error('Error refreshing data:', error);
      }
    }, 30000);
  }

  getColor(val) {
    if (['1'].includes(val)) return 'green';
    if (['2', '3'].includes(val)) return 'lightGreen';
    if (['D', 'd', 'S', 's'].includes(val)) return 'red';
    return 'gray';
  }

  getShoeInfo(val = '') {
    if (val === true) return 'C';
    if (val === false) return 'Ȼ';
    return '-';
  }

  renderHtml() {
    if (!this.data) return;

    const style = `
      <style>
        :host {
          font-family: 'Segoe UI', sans-serif;
          display: block;
          color: white;
          background-color: #1e1e1e;
          border-radius: 4px;
          overflow: hidden;
          width: 100%;
          
        }



        .group {
          border-bottom: 1px solid #333;
        }

        .number-box {
          width: 14px;
          height: 14px;
          border: 1px solid rgba(199, 199, 199, 1);
          border-radius: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 4px;
          font-size: 10px;
          padding-right: 6px;
          padding-left: 6px;
          background: rgba(33, 33, 33, 1);
        }

        *, *::before, *::after {
          box-sizing: border-box;
        }

        .row-grid:hover {
          background: #3a3a3a;
        }

        .outer-header{
          background: #131212;
          min-height: auto;
          box-sizing: border-box;
          display: grid;
          grid-template-columns: 0.3fr 2fr 0.5fr 0.5fr 1.5fr 0.7fr 0.6fr;
          align-items: center;
          padding: 6px 6px;
          font-size: 10px;
          font-weight: 500;
        }
        .row-grid {
          cursor: pointer;
          background: #3B3737;
          min-height: auto;
          box-sizing: border-box;
          display: grid;
          grid-template-columns: 0.3fr 2fr 0.5fr 0.5fr 1.5fr 0.7fr 0.6fr;
          align-items: center;
          padding: 6px 6px;
          border-bottom: 1px solid #131212;
        }

        .scratched {
          color: red;
          text-decoration: line-through;
        }

        .details {
          display: none;
          background: #1a1a1a;
          margin-left: 3px;
        }

        .race-row {
          display: grid;
          grid-template-columns: 1fr 0.7fr 1.1fr 1fr 0.5fr 0.8fr 0.6fr 0.6fr 0.6fr;
          padding: 4px 0;
        }

        .race-row.header-row {
          font-weight: 400;
          font-size: 10px;
        }

        .form{
          display: flex;
          gap: 1px;
          align-items: center;
          justify-content: center;
        }
          .form > span:last-child {
            margin-left: 0;
          }
        .highlight {
          justify-content: center;
          align-items: center;
          display: inline-flex;
          width: 12px;
          height: 18px;
          padding-right: 6px;
          padding-left: 6px;
          font-size: 12px;
          font-weight: 500;
        }

        .capitalize {
          text-transform: uppercase;
          margin-left: 1px;
        }

        .divider {
          background: #000;
          padding: 8px 10px;
          font-weight: bold;
          font-size: 0.9em;
        }

        .shoeSpan {
          font-size: 12px;
          text-align: center;
        }

        .tableHeader{
          font-size: 10px;
          font-weight: 400;
        }

        .driverName{
        font-size: 12px; 
        font-weight: 400; 
        color: rgba(225, 225, 229, 1);
        }

        .tableText {
          font-size: 12px;
          font-weight: 400;
          }

        @media screen and (max-width: 335px) {
          .outerHeaderText{
          font-size: 9px; 
          font-weight: 500;
        }
        .shoeSpan {
          font-size: 10px;
          text-align: center;
        }
          .rowText{
          font-size: 10px; 
          font-weight: 400;
          }
        }
        @media screen and (min-width: 336px) {
          .outerHeaderText{
          font-size: 10px;
          font-weight: 400;
          }
          .shoeSpan {
          font-size: 12px;
          text-align: center;
          }
          .rowText{
          font-size: 12px; 
          font-weight: 400;
          }
        }

        .whiteText { color: #FFFFFF; }
        .blackText { color: #131212; }

        .green { background: #038B14; }
        .lightGreen { background: #CAFFBB; }
        .red { background: #DB3021; }
        .gray { background: #CED0D4; }
        .redText { color: #ED0000; }
        .greenText { color: green; }
      </style>
    `;

    const horses = this.data.horses ?? [];
    let html = `
      <div class="outer-header">
        <div></div>
        <div class="outerHeaderText">Häst & Kusk</div>
        <div class="outerHeaderText">Skor</div>
        <div class="outerHeaderText" style="text-align: center;">Vagn</div>
        <div class="outerHeaderText" style="text-align: center;">Form</div>
        <div class="outerHeaderText" style="text-align: center;">R-tid</div>
        <div class="outerHeaderText" style="text-align: right;">Kr/start</div>
      </div>
    `;

    let dividerShown = false;

    html += horses.map((entry, index) => {
      let divider = '';
      if (entry.addedDistance === 20 && !dividerShown) {
        divider = `<div class="divider">Tillägg 20 meter</div>`;
        dividerShown = true;
      }

      const formHtml = entry.formRow?.reverse().map(f =>
        `<span class="highlight ${this.getColor(f)} ${['1', 'D', 'S'].includes(f) ? 'whiteText' : 'blackText'}">${f ?? '-'}</span>`
      ).join('') ?? '';

      const pastRacesHtml = entry.pastPerformances?.length
        ? `
          <div class="race-row header-row">
            <div>Datum</div><div>Bana</div><div>Kusk</div><div>Dist.</div>
            <div>Res</div><div>Km-Tid</div><div>Skor</div><div>Vagn</div><div>Pris</div>
          </div>
          ${entry.pastPerformances.map((race, index) => `
            <div class="race-row" style="background: ${index % 2 === 0 ? '#252526' : '#303030'};">
              <div class="tableText">${race.formattedDate ?? '-'}</div>
              <div class="tableText">${race.trackCode ?? '-'}</div>
              <div class="tableText">${race.driver?.shortName ?? '-'}</div>
              <div class="tableText">${race.formattedDistance ?? '-'}</div>
              <div class="tableText">${race.formattedPlace ?? '-'}</div>
              <div class="tableText">${race.formattedKmTime ?? '-'}</div>
              <div style="display: flex;"><span class="tableText">${this.getShoeInfo(race.shoeInfo?.foreshoes)}</span> <span class="tableText" style="margin-left: 2px;">${this.getShoeInfo(race.shoeInfo?.hindshoes)}</span></div>
              <div class="tableText">${race.formattedSulky ?? '-'}</div>
              <div class="tableText">${race.formattedFirstPrize ?? '-'}</div>
            </div>
          `).join('')}
        ` : `<div style="padding: 10px;">Inga lopp</div>`;

      const isOpen = this.openStates.get(index);

            return `
        ${divider}
        <div class="group">
          <div class="row-grid">
            <div class="number-box"><span>${entry.startNr ?? '-'}</span></div>
            <div>
              <div style="font-weight: 500; font-size: 12px;" class="${entry.scratched ? 'scratched' : ''}">${entry.name ?? '-'}</div>
              <div class="${entry.driverChanged ? 'redText' : ''} driverName">${entry.formattedDriverName ?? '-'}</div>
            </div>
            <div style="display: flex;align-items: start;"><span class="shoeSpan ${entry.foreshoesHighlight ? 'redText' : ''}">${this.getShoeInfo(entry.shoeInfo?.foreshoes)}</span><span class="shoeSpan ${entry.hindshoesHighlight ? 'redText' : ''}" style="padding: 0px 4px;">${this.getShoeInfo(entry.shoeInfo?.hindshoes)}</span></div>
            <div class="${entry.sulkyHighlight ? 'redText' : ''} rowText" style="text-align: center;">${entry.formattedSulky ?? '-'}</div>
            <div class="form">${formHtml}</div>
            <div class="rowText" style="text-align: center;">${entry.record ?? '-'}</div>
            <div class="rowText" style="text-align: right;">${entry.earningsPerStart ?? '-'}</div>
          </div>
          <div class="details" style="display: ${isOpen ? 'block' : 'none'}">${pastRacesHtml}</div>
        </div>
      `;
    }).join('');

  this.shadowRoot.querySelectorAll('.group').forEach((groupEl, index) => {
  const isOpen = groupEl.querySelector('.details')?.style.display === 'block';
  this.openStates.set(index, isOpen);
  });

    this.shadowRoot.innerHTML = style + html;

    this.shadowRoot.querySelectorAll('.row-grid').forEach((header, index) => {
      header.addEventListener('click', () => {
        const content = header.nextElementSibling;
        const isVisible = content.style.display === 'block';
        content.style.display = isVisible ? 'none' : 'block';
        this.openStates.set(index, !isVisible);
      });
    });
  }
}

customElements.define('event-component', EventComponent);


 })(window);